import type {Evaluator} from "@cm/graph-v3"
import {graphNode, lazyDefinition} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {priorNodeClassChain} from "#template/versioning"
import {templateListNodeDefinition} from "#template/template-list-node/validation"
import {TemplateListNode} from "#template/template-list-node/template-list-node"
import {TemplateNode} from "#template/template-node/template-node"
import {templateOwningContainerMarker, type TemplateOwningContainer} from "#template/role-markers"
import type {PartlyVisitedResult, TemplateNodeContext} from "#template/template-node/types"
import {skipped} from "#template/template-node/constants"
import {visit} from "#template/template-node/visit-helpers"
import type {TemplateListNodeParameters} from "#template/template-list-node/types"

// Renamed from `Nodes`; versionChain keeps saved `Nodes` graphs deserializing.
const definition = lazyDefinition(() => ({...templateListNodeDefinition("TemplateNodes", graphNode(TemplateNode)), versionChain: priorNodeClassChain("Nodes")}))

@registerTemplateGraphNode
export class TemplateNodes extends TemplateListNode<TemplateNode> implements TemplateOwningContainer {
    get [templateOwningContainerMarker]() {
        return true as const
    }
    public override get definition() {
        return definition()
    }

    visit(evaluator: Evaluator<TemplateNodeContext>, visitNode: (node: TemplateNode) => boolean) {
        const {context} = evaluator
        if (context.skipNode?.(this)) return skipped
        const result = {list: this.parameters.list.map((entry) => (visitNode(entry) ? visit(entry, evaluator) : skipped))} as PartlyVisitedResult<
            TemplateListNodeParameters<TemplateNode>
        >
        context.onPostUnskippedNode?.(this)
        return result
    }
}
